export const LOGIN_FAIL_EMAIL = "Please enter correct email.";
export const LOGIN_FAIL_PASSWORD = 'Your password must contain lowercase, uppercase, minimum one number and password length must minimum 8';



